import React, { useState, forwardRef } from 'react'
import { Root, Item, Header, Content, Trigger } from '@radix-ui/react-accordion'

import '../index.scss'

const AccordionTrigger = forwardRef(
	(
		{
			children,
			isOpen,
			onToggle,
			styleHeader,
			ariaLabelReference,
			hasTriggerBody,
			hasChevronText,
			...props
		},
		forwardedRef
	) => {
		function returnClasseNameTriggerBody() {
			let className = 'accordion__trigger__body'

			if (isOpen) className += ' accordion__trigger__body--hidden'

			return className
		}

		return (
			<Header className="accordion__header">
				<Trigger
					className="accordion__trigger"
					{...props}
					ref={forwardedRef}
					aria-describedby={ariaLabelReference}
					asChild>
					<div className="accordion__trigger__header-container">
						<div
							className="accordion__trigger__header"
							style={{ ...styleHeader }}>
							{children[0]}
							<button
								className="accordion__trigger__selector"
								onClick={onToggle}>
								<div className="accordion__trigger__chevron" aria-hidden />
								{hasChevronText && (
									<span>{isOpen ? 'Esconder' : 'Detalhes'}</span>
								)}
							</button>
						</div>
						{hasTriggerBody && children[1] && (
							<div className={returnClasseNameTriggerBody()}>
								<div>{children[1]}</div>
							</div>
						)}
					</div>
				</Trigger>
			</Header>
		)
	}
)

const AccordionContent = forwardRef(
	({ children, style, ariaLabelReference, ...props }, forwardedRef) => (
		<Content
			className="accordion__content"
			style={style}
			aria-labelledby={ariaLabelReference}
			aria-describedby={ariaLabelReference}
			{...props}
			ref={forwardedRef}>
			{children}
		</Content>
	)
)

function Accordion({
	triggerHeader,
	triggerBody,
	content,
	styleHeader,
	defaultValue,
	ariaLabelReference,
	style,
	customTrigger,
	hasTriggerBody = true,
	hasChevronText = true,
	onExpand = () => {},
}) {
	const [itemOpen, setItemOpen] = useState(defaultValue)

	async function handleToggleAccordion() {
		setItemOpen((prevValue) => (prevValue === 'item-1' ? '' : 'item-1'))
		onExpand()
	}

	if (customTrigger) {
		return (
			<Root className="accordion" type="single" value={itemOpen} collapsible>
				<Item className="accordion__item" value="item-1">
					{customTrigger({
						isOpen: itemOpen === 'item-1',
						onToggle: handleToggleAccordion,
					})}
					<AccordionContent style={style}>{content}</AccordionContent>
				</Item>
			</Root>
		)
	}

	return (
		<Root
			className="accordion"
			type="single"
			value={itemOpen}
			collapsible
			onValueChange={(value) => {
				if (value === 'item-1') onExpand()
			}}>
			<Item className="accordion__item" value="item-1">
				<AccordionTrigger
					isOpen={itemOpen === 'item-1'}
					styleHeader={styleHeader}
					ariaLabelReference={ariaLabelReference}
					onToggle={handleToggleAccordion}
					hasTriggerBody={hasTriggerBody}
					hasChevronText={hasChevronText}>
					{triggerHeader}
					{hasTriggerBody && triggerBody}
				</AccordionTrigger>
				<AccordionContent style={style} ariaLabelReference={ariaLabelReference}>
					{content}
				</AccordionContent>
			</Item>
		</Root>
	)
}

export default Accordion
